// extracted by mini-css-extract-plugin
module.exports = {"waypoint":"styles_waypoint__2dsvp"};